var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsrIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5625C6.6225 9.5625 4.6875 7.6275 4.6875 5.25C4.6875 2.8725 6.6225 0.9375 9 0.9375C11.3775 0.9375 13.3125 2.8725 13.3125 5.25C13.3125 7.6275 11.3775 9.5625 9 9.5625ZM9 2.0625C7.245 2.0625 5.8125 3.495 5.8125 5.25C5.8125 7.005 7.245 8.4375 9 8.4375C10.755 8.4375 12.1875 7.005 12.1875 5.25C12.1875 3.495 10.755 2.0625 9 2.0625Z",
    fill: "#3D5064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.1875C12.6776 11.1875 15.5049 13.6568 15.5049 16.5C15.5049 16.5131 15.4996 16.5287 15.4854 16.543C15.4711 16.5572 15.4554 16.5625 15.4424 16.5625C15.4294 16.5624 15.4136 16.5572 15.3994 16.543C15.3852 16.5287 15.3799 16.513 15.3799 16.5C15.3799 13.5363 12.4041 11.3125 9 11.3125C5.59592 11.3125 2.62012 13.5363 2.62012 16.5C2.62012 16.5131 2.61488 16.5287 2.60059 16.543C2.5863 16.5573 2.57068 16.5625 2.55762 16.5625C2.54455 16.5625 2.52894 16.5573 2.51465 16.543C2.50036 16.5287 2.49512 16.5131 2.49512 16.5C2.49512 13.6568 5.32245 11.1876 9 11.1875Z",
    fill: "#3D5064",
    stroke: "#3D5064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsrIcon);
export default __webpack_public_path__ + "static/media/usr_icon.9c2370c7d5272152acc921969fc30dfc.svg";
export { ForwardRef as ReactComponent };